/* global femcare */

femcare.navigation.cookieNotice = {
    init: function() {
        var $cookieNotice = $('.cookie-notice');

        if ($cookieNotice.length) {
            $cookieNotice.addClass('show');

            var cookieExpireDate = new Date();
            cookieExpireDate.setFullYear(cookieExpireDate.getFullYear() + 1);

            var cookieName = $cookieNotice.data('cookie-name');

            $('.cookie-notice__close-button').on('click', function() {
                document.cookie =
                    cookieName +
                    '=true; expires=' +
                    cookieExpireDate.toGMTString() +
                    ';path=/;';
                $cookieNotice.removeClass('show');

                // Remove element after 1 sec (when css transition finished).
                setTimeout(function() {
                    $cookieNotice.remove();
                }, 1000);
            });
        }
    }
};
